/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import DataTable from "react-data-table-component";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { Link } from "react-router-dom";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Container } from "./styles";

interface ITable {
  columns: any[];
  data: any[];
  title?: any;
  clearLocalStorage?: boolean;
}

const CardTable: React.FC<ITable> = ({
  columns,
  data,
  title,
  clearLocalStorage,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(
    columns.map((col) => col.selector)
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleColumnVisibility = (column: string) => {
    setVisibleColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const customColumns = columns.filter((col) =>
    visibleColumns.includes(col.selector)
  );

  useEffect(() => {
    if (clearLocalStorage) {
      localStorage.removeItem("visibleColumns");
    }
  }, [clearLocalStorage]);

  useEffect(() => {
    const storedColumns = localStorage.getItem("visibleColumns");
    if (storedColumns) {
      setVisibleColumns(JSON.parse(storedColumns));
    } else {
      localStorage.setItem("visibleColumns", JSON.stringify(visibleColumns));
    }
  }, [columns]); // Reexecuta ao mudar as colunas padrão

  // Atualiza o localStorage sempre que o estado visibleColumns mudar
  useEffect(() => {
    localStorage.setItem("visibleColumns", JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center",
        textAlign: "center",
        color: "var(--purple)",
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        justifyContent: "center",
        textAlign: "center",
        color: "var(--orange)",
        fontSize: "13px",
      },
    },
    rows: {
      style: {
        textAlign: "center",
        justifyContent: "center",
      },
    },
  };

  return (
    <Container>
      {/* Botão para abrir o modal */}
      <div className="columns">
        <Button
          startIcon={<SettingsIcon />}
          variant="outlined"
          onClick={toggleModal}
          className="buttoncolum"
        >
          Configurar Colunas
        </Button>
      </div>

      {/* Modal */}
      <Modal open={isModalOpen} onClose={toggleModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            color: "var(--purple)",
            fontWeight: "bold",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Configuração de Colunas
          </Typography>
          {columns.map((col) => (
            <FormControlLabel
              key={col.selector}
              control={
                <Checkbox
                  checked={visibleColumns.includes(col.selector)}
                  onChange={() => toggleColumnVisibility(col.selector)}
                  style={{ color: "var(--orange)" }}
                />
              }
              label={col.name.props?.children || col.name}
            />
          ))}
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={toggleModal}
              style={{ backgroundColor: "var(--purple)" }}
            >
              Fechar
            </Button>
          </Box>
        </Box>
      </Modal>
      <div
        style={{
          overflowX: "auto",
          WebkitOverflowScrolling: "touch", // Para melhorar o scroll em iOS
          width: "100%",
        }}
      >
        <DataTable
          columns={customColumns}
          data={data}
          title={title}
          expandableRows
          expandableRowExpanded={(row) => row.isExpanded}
          expandableRowsComponent={({ data }) => (
            <div style={{ padding: "10px 20px" }}>
              {data.recharges && data.recharges.length > 0 ? (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead
                    style={{ textAlign: "center", color: "var(--purple)" }}
                  >
                    <tr>
                      <th style={{ textAlign: "center" }}>ID</th>
                      <th style={{ textAlign: "center" }}>Código</th>
                      <th style={{ textAlign: "center" }}>Data do pedido</th>
                      <th style={{ textAlign: "center" }}>
                        Forma de pagamento
                      </th>
                      <th style={{ textAlign: "center" }}>ID Tacom</th>
                      <th style={{ textAlign: "center" }}>Status</th>
                      <th style={{ textAlign: "center" }}>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.recharges.map((recarga: any) => (
                      <tr key={recarga.id} style={{ height: "30px" }}>
                        <td className="IdLink">{recarga.id}</td>
                        <td>{recarga.external_code}</td>
                        <td>{recarga.created_at}</td>
                        <td>{recarga.form_of_payment_display}</td>
                        <td>{recarga.tacom_order_id}</td>
                        <td>{recarga.status_display}</td>
                        <td>{`R$ ${formatCurrency(
                          Number(recarga.amount)
                        )}`}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div style={{ padding: "10px", color: "#999" }}>
                  Sem informações de recargas.
                </div>
              )}
            </div>
          )}
          expandableIcon={{
            collapsed: (
              <Tooltip
                title="Mostrar recargas"
                style={{ color: "var(--purple)" }}
                className="tooltipicon"
              >
                <KeyboardArrowRightIcon />
              </Tooltip>
            ),
            expanded: (
              <Tooltip
                title="Ocultar recargas"
                style={{ color: "var(--purple)" }}
                className="tooltipicon"
              >
                <KeyboardArrowDownIcon />
              </Tooltip>
            ),
          }}
        />
      </div>
    </Container>
  );
};

export { CardTable };
